import { BaseComponent } from "../../BaseComponent";
import { BottoneAPI } from "../../BottoneAPI";
import * as Dati from "../../../Dati";
import * as Glob from "../../../Globale";
import { Trad } from "../../Trad";
import ChiamaWeb, { CChiamaWebParametri } from "../../../ChiamaWeb";
import { DocumentComponent } from "./DocumentComponent";
import * as React from "react";
import { CDocument } from "../../../Dati";
import { CDocumentExtended } from "../../../Dati";

interface IDocumentHocComponentProps {
    Label: string;
    ExtendedValues?: Dati.Dictionary<string> | Glob.DatiJSON;
    SaveURL?: string;
    GetListURL: string;
    SpecialInformationEnabled?: boolean
    DeleteEnabled?: boolean;
    AddEnabled?: boolean;
}

interface IDocumentHocComponentState {
    Files: CDocument[];
    URL: string;
}

export class DocumentHocComponent extends BaseComponent<IDocumentHocComponentProps, IDocumentHocComponentState> {
    constructor(props: any) {
        super(props);
        this.state = { Files: [], URL: "" };
        this.PrepareFileToSend = this.PrepareFileToSend.bind(this);
        this.OnFileSaved = this.OnFileSaved.bind(this);
        this.SendRequest = this.SendRequest.bind(this);
        this.GetDocumentsList = this.GetDocumentsList.bind(this);
        this.OnRemove = this.OnRemove.bind(this);
    }

    componentDidMount(): void {
        this.GetDocumentsList(this.props, false);
    }

    UNSAFE_componentWillReceiveProps(nextProps: IDocumentHocComponentProps) {
        this.GetDocumentsList(nextProps, false);
    }

    private OnFileSaved(dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), Trad.Trad(dati.ErrTesto));
        } else {
            this.GetDocumentsList(this.props, true);
        }
    }

    private PrepareFileToSend(InputFile?: File, AdditionalData?: CDocument): any {
        if (InputFile != undefined || AdditionalData) {
            let FileData: Dati.CDocumentExtended = new Dati.CDocumentExtended();
            if (AdditionalData) {
                FileData = { ...FileData, ...AdditionalData };
            } else {
                FileData.DownloadFileName = InputFile && InputFile.name ? InputFile.name : "";
                FileData.Description = FileData.Description ? FileData.Description : "";
            }
            if (this.props.ExtendedValues != undefined) {

                let ExtendedValues: Dati.Dictionary<string>;
                if (typeof (this.props.ExtendedValues) == "string")
                    ExtendedValues = JSON.parse(this.props.ExtendedValues);
                else
                    ExtendedValues = this.props.ExtendedValues;

                FileData.ExtendedValues = ExtendedValues;

                if (AdditionalData && AdditionalData.ID_Document > 0) {
                    delete FileData.ExtendedValues;
                }
            }

            const FD = new FormData();
            if (InputFile) {
                FD.append("file", InputFile);
            }
            FD.append("ingr", JSON.stringify(FileData));
            return FD;
        } else {
            return false;
        }
    }


    private OnRemove(file: CDocumentExtended) {
        const Param: CChiamaWebParametri = {
            URL: `/api/Document?ID_Document=${file.ID_Document}`,
            Metodo: "DELETE",
            OnRis: (sender: ChiamaWeb, dati: any) => this.GetDocumentsList(this.props, true)
        };
        return this.SendRequest(Param);
    }

    private GetDocumentsList(props: IDocumentHocComponentProps, force: boolean) {
        const Param: CChiamaWebParametri = {
            URL: props.GetListURL,
            OnRis: (sender: ChiamaWeb, dati: any) => {
                this.setState({ Files: dati.Dato, URL: props.GetListURL })
            }
        };
        if (props.GetListURL != this.state.URL || force) {
            return this.SendRequest(Param);
        }
    }

    private OnErroreBottoneAPI(sender: BottoneAPI) {
    }

    private SendRequest(Params: CChiamaWebParametri) {
        let ChiamaWebRequest = new ChiamaWeb();
        ChiamaWebRequest.Chiama(Params);
    }

    render() {
        return <DocumentComponent Files={JSON.stringify(this.state.Files)} Label={this.props.Label}
            GetDocumentsList={() => { this.GetDocumentsList(this.props, false) }}
            SaveURL={this.props.SaveURL == undefined ? "/api/Document" : this.props.SaveURL} OnFileSaved={this.OnFileSaved}
            OnErroreBottoneAPI={this.OnErroreBottoneAPI} OnRemove={this.OnRemove}
            OnSubmitSave={this.PrepareFileToSend} SpecialInformationEnabled={this.props.SpecialInformationEnabled}
            AddEnabled={this.props.AddEnabled} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/custom/Document/DocumentHocComponent.tsx